//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileSaver from "file-saver";
export default {
  name: "",
  data() {
    return {
      enter_keyword: "",
      active_tab: 1,
      list_ary: [],
      qq_media_url: "http://qq.littlewindy.com/",
      music_pic: [
        {
          src: "static/img/music/zwza.png",
          name: "中文最爱"
        },
        {
          src: "static/img/music/zwlx.png",
          name: "中文流行"
        },
        {
          src: "static/img/music/zwjd.png",
          name: "中文经典"
        },
        {
          src: "static/img/music/yyjd.png",
          name: "粤语经典"
        },
        {
          src: "static/img/music/ywgq.png",
          name: "英文歌曲"
        },
        {
          src: "static/img/music/zrly.png",
          name: "自然录音"
        },
        {
          src: "static/img/music/qyyq.png",
          name: "轻音乐曲"
        },
        {
          src: "static/img/music/wxzf.png",
          name: "武侠之风"
        },
        {
          src: "static/img/music/wdpz.png",
          name: "悟道篇章"
        },
        {
          src: "static/img/music/yxsx.png",
          name: "游戏赏析"
        }
      ],
      list_search: [], //搜索列表
      play_the_num: {
        index: "",
        src: "",
        title: "请选择",
        author: "",
        state: false
      }
    };
  },
  mounted() {
    this.$store.dispatch("titleAction", "音乐");
    this.search();
  },
  methods: {
    onItemClick(num) {
      //切换面板
      this.active_tab = num;
    },
    search: function() {
      //左侧面板
      this.$http
        .get("/music/music.php", {
          params: {
            form: "music",
            orderByObj: "id",
            orderBy: "desc"
          }
        })
        .then(res => {
          this.list_ary = res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDetail(item) {
      //左侧面板进入详情
      this.$router.push({
        path: "/music_detail",
        query: item
      });
    },
    play_the_song() {
      //底部播放
      if (!this.$refs.myAudio.src) {
        this.$message({
          showClose: true,
          message: "请选择",
          type: "error"
        });
        return;
      }
      this.play_the_num.state = !this.play_the_num.state;
      this.$refs.myAudio.play();
    },
    stop_the_song() {
      //底部暂停
      this.play_the_num.state = !this.play_the_num.state;
      this.$refs.myAudio.pause();
    }
  },
  components: {}
};



// WEBPACK FOOTER //
// ./src/components/music/index.vue